import { getSellerCommunicationEnquiries } from 'Pages/api/seller-communications/enquiries/client.api';
import { getSellerCommunicationUnsentMessagesCount } from 'Pages/api/seller-communications/unsent-messages-count/client.api';
import { logger } from 'Services/logger/logger';

import { CountStore, StatusStore } from './stores';

const getCommunicationStatuses = async (enquiryIds: number[]) => {
	try {
		const { items } = await getSellerCommunicationEnquiries({ enquiryIds });
		StatusStore.setState({
			statuses: items.reduce((acc, sale) => ({ ...acc, [sale.enquiryId]: sale.status }), {}),
		});
	} catch (error) {
		logger.error({
			error: error as Error,
			message: 'Failed to fetch sale statuses',
			scope: 'getCommunicationStatuses',
		});
	}
};

const getCommunicationsCount = async () => {
	try {
		const { countOfUnsentMessages } = await getSellerCommunicationUnsentMessagesCount();
		CountStore.setState({ unsentMessagesCount: countOfUnsentMessages });
	} catch (error) {
		logger.error({
			error: error as Error,
			message: 'Failed to fetch communications count',
			scope: 'getCommunicationsCount',
		});
	}
};

const getCommunicationInfo = (enquiryIds: number[]) => {
	StatusStore.setState({ enquiryIds });
	void getCommunicationsCount();
	if (enquiryIds.length) {
		void getCommunicationStatuses(enquiryIds);
	}
};

const updateCommunicationInfo = () => {
	const { enquiryIds } = StatusStore.getState();
	void getCommunicationsCount();
	if (enquiryIds.length) {
		void getCommunicationStatuses(enquiryIds);
	}
};

export const infoService = {
	getCommunicationInfo,
	updateCommunicationInfo,
};
